import { Quiz } from "@mui/icons-material";
import { Masonry } from "@mui/lab";
import { Box, Button, Collapse, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ActiveChallengeCard from "../../components/cards/ActiveChallengeCard";
import ChallengeCard from "../../components/cards/ChallengeCard";
import PointIcon from "../../components/icons/Point";
import ChallengePointsInfo from "../../components/infomodals/ChallengePointsInfo";
import { categories } from "../../consts/challenges";
import { handleBackToTopClick } from "../../consts/helpers";

export default function ChallengesList({ uid, setOpenChallenge, challengesList, activeChallengeIds, filteredChallenges, selectedCategory, handleCategoryChange }) {
    // For more info popup
    const [openPopup, setOpenPopup] = useState(false);
    const handleOpen = () => setOpenPopup(true);
    const handleClose = () => setOpenPopup(false);

    return (
        <>
        <Collapse in={activeChallengeIds.length > 0}>
            <Stack spacing={1} >
                <Box className='spread-x'>
                    <Typography variant="h6">Active Challenges</Typography>
                    <PointIcon size={30} />
                </Box>
                <Box display="flex" flexDirection="column" gap={2}>
                    {Object.entries(challengesList)
                        .filter(([key]) => activeChallengeIds.includes(key))
                        .map(([cid, cdetails], key) => (
                        <Box key={key}>
                            <ActiveChallengeCard uid={uid} cid={cid} details={cdetails} photo={cdetails.headerImg} setOpenChallenge={setOpenChallenge} />
                        </Box>
                    ))}
                </Box>
            </Stack>
        </Collapse>

        <Stack spacing={1} >
            <Box className='spread-x'>
                <Typography variant="h6">Reduce your carbon today!</Typography>
                <IconButton onClick={handleOpen} >
                    <Quiz />
                </IconButton>
            </Box>
            <Box className='scrollable-x'>
                <Button className={`pill_btn challenge_btn ${selectedCategory === '' ? 'active' : ''}`} onClick={() => handleCategoryChange('')}>All</Button>
                {categories.map((category, index) => (
                    <Button className={`pill_btn challenge_btn ${selectedCategory === category ? 'active' : ''}`} key={index} onClick={() => handleCategoryChange(category)}>
                        {category}
                    </Button>
                ))}
            </Box>
            <Masonry columns={2} spacing={2}>
            {
                filteredChallenges.map(([cid, cdetails], key) => (
                    <Box key={key}>
                        <ChallengeCard uid={uid} cid={cid} details={cdetails} photo={cdetails.headerImg} setOpenChallenge={setOpenChallenge} />
                    </Box>
                ))
            }
            </Masonry>
            <Box className='centered-y'>
                <Typography variant="caption" sx={{ cursor: 'pointer', '&:hover': { color: 'var(--pri-purple)' } }} onClick={handleBackToTopClick}>Back to Top</Typography>
            </Box>

            <ChallengePointsInfo open={openPopup} handleClose={handleClose} />
        </Stack>
        </>
    )
}